import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SsoLoginComponent } from './pages/sso-login.component';
import { SsoLogoutComponent } from './pages/sso-logout.component';
import { LandingPageComponent } from './global-components/desktop-landing-page/landing-page.component';
import { MobLandingPageComponent } from './global-components/mobile-landing-page/mob-landing-page.component';
import { DeviceGuard } from './guard/device-guard';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'mobile-landing',
        pathMatch: 'full',
    },
    {
        path: 'desktop-landing',
        pathMatch: 'full',
        component: LandingPageComponent,
    },
    {
        path: 'mobile-landing',
        canActivate: [DeviceGuard],
        component: MobLandingPageComponent,
    },
    {
        path: 'sso',
        pathMatch: 'full',
        component: SsoLoginComponent,
    },
    {
        path: 'logout',
        component: SsoLogoutComponent,
    },
    {
        path: 'post-signup/landing',
        loadChildren: () =>
            import('./pages/post-signup-landing/post-signup-landing.module').then((m) => m.PostSignupLandingModule),
    },
    {
        path: '**',
        redirectTo: 'mobile-landing',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
